import React from "react"
import { Trans } from "@lingui/react"
import PropTypes from "prop-types"

// Define status translations for Lingui extraction
// These are used dynamically but need to be statically defined for extraction
const STATUS_TRANSLATIONS = {
  successful: <Trans id="successful">Successful</Trans>,
  pending: <Trans id="pending">Pending</Trans>,
  processing: <Trans id="processing">Processing</Trans>,
  failed: <Trans id="failed">Failed</Trans>,
}

const commonStyle = {
  borderRadius: "3px",
  textTransform: "capitalize",
  padding: "0 4px",
  fontWeight: "500",
  fontSize: "12px",
}
const successfulStyle = {
  border: "1px solid green",
  color: "green",
}
const failedStyle = {
  border: "1px solid red",
  background: "red",
  color: "#fff",
}
const pendingStyle = {
  border: "1px solid #ccc",
  color: "#ccc",
}
const processingStyle = {
  border: "1px solid",
  //   color: "yellow",
  color: "rgb(227, 111, 30)",
  borderColor: "rgb(227, 111, 30)",
}
const styles = {
  processingStyle,
  pendingStyle,
  failedStyle,
  successfulStyle,
}

const View = (props) => {
  return (
    <div
      style={{
        ...commonStyle,
        ...styles[`${props.status.toLocaleLowerCase()}Style`],
      }}
    >
      <Trans id={props.status.toLowerCase()}>{props.status}</Trans>
    </div>
  )
}

View.propTypes = {
  status: PropTypes.string,
}

export default View
